import { Option } from 'funfix-core';
import { List } from 'immutable';
import { reflect } from '../utils/promise-utils';
import ProductPlatformBackend from './backends/ProductPlatform';
const BACKENDS = List([new ProductPlatformBackend()]);
export function initializeBackends(hostInfo, userId) {
  return Promise.all(BACKENDS.map(b => reflect(b.initialize(hostInfo, userId)).then(r => {
    r.swap().map(error => {
      console.error('Analytics error', error);
    });
    return r;
  })).toArray()
  // Unfortunately, Flow returns us a Promise of Iterable<mixed> -_- https://github.com/facebook/flow/blob/master/lib/core.js#L594
  ).then(responses => {
    const errResponse = Option.of(responses.find(r => r.fold(value => value, () => false)));
    return errResponse.map(er => Promise.reject(er)).getOrElseL(() => Promise.resolve());
  });
}
export function sendEvent(event) {
  BACKENDS.forEach(b => b.sendEvent(event));
}
export function sendPageViewEvent(pageViewEvent) {
  BACKENDS.forEach(b => b.sendPageViewEvent(pageViewEvent));
}